// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-legend{float:left;margin:0;padding:0 6px 6px 6px;width:100%;list-style:none;font-size:11px;background:#fff}.chart-legend__item{position:relative;float:left;margin:5px 10px;padding-left:14px;margin-bottom:6px}.chart-legend__item:last-child{margin-bottom:0}.chart-legend__bubble{display:block;position:absolute;top:50%;left:0;margin-top:-4px;width:8px;height:8px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
